import React from "react";
import "components/Campaign/BannerComponent.scss";
import { processWagtailImage } from "components/Wagtail/WagtailImage";
import { convertHtmlToReact } from "@hedgedoc/html-to-react/dist/convertHtmlToReact";
import useWindowDimensions from "utils/WindowWidth";
import BannerForm from "./BannerForm";
import { useLocation } from "react-router-dom";

const BannerComponent = ({
    form,
    image,
    header_text,
    main_text,
    secondary_text,
    primary_colour,
    highlight_text_colour,
    banner_text_colour,
    submit_button_text_colour
  }) => {
  const { width } = useWindowDimensions();
  const pageType = useLocation().pathname.split("/")[3]

  // device specific views
  const tabletView = () => {
    return (
      <>
        <div className={pageType === 'residential' ? "banner-component-container is-residential" : "banner-component-container"} tabIndex="0" style={{
          backgroundImage: `url(${processWagtailImage(
            image
          )})`,
        }}>
          <div className="left-content">
            <div className="main-text" style={{color: banner_text_colour}}>
              {convertHtmlToReact(main_text)}
            </div>
            <div className="secondary-text" style={{color: banner_text_colour}}>
              {convertHtmlToReact(secondary_text)}
            </div>
          </div>
        </div>
          <div className="right-content">
            <BannerForm
              form={form}
              primary_colour={primary_colour}
              highlight_text_colour={highlight_text_colour}
              banner_text_colour={banner_text_colour}
              submit_button_text_colour={submit_button_text_colour}
            />
          </div>
      </>
    )
  }
  const desktopView = () => {
    return (
      <>
        <div className={pageType === 'residential' ? "banner-component-container is-residential" : "banner-component-container"} tabIndex="0" style={{
          backgroundImage: `url(${processWagtailImage(
            image
          )})`,
        }}>
          <div className="left-content">
            <div className="main-text" style={{color: banner_text_colour}}>
              {convertHtmlToReact(main_text)}
            </div>
            <div className="secondary-text" style={{color: banner_text_colour}}>
              {convertHtmlToReact(secondary_text)}
            </div>
          </div>
        <div className="right-content">
          <BannerForm
            form={form}
            primary_colour={primary_colour}
            highlight_text_colour={highlight_text_colour}
            banner_text_colour={banner_text_colour}
            submit_button_text_colour={submit_button_text_colour}
          />
        </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="banner-header-text">
        <span>{convertHtmlToReact(header_text)}</span>
      </div>
      {
        width > 1024
        ?
            desktopView()
        :
            tabletView()
      }
    </>
  );
};

export default BannerComponent;
